export const posts = [
  {
    slug: "choose-stream-after-10th",
    number: "01",
    title: "How to Choose a Stream After 10th: A Practical Framework",
    excerpt:
      "The stream you pick at 15 quietly decides the ten years that follow. Here's a working framework — not a personality quiz — for making that decision with clarity.",
    category: "Students",
    readTime: "7 min read",
    date: "Nov 24, 2025",
    cover: "https://images.pexels.com/photos/8084481/pexels-photo-8084481.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "in-demand-skills-2026",
    number: "02",
    title: "5 In-Demand Skills Employers Are Actually Hiring For in 2026",
    excerpt:
      "Cutting through the noise. What global recruiters — the ones writing the offer letters — are actually screening for right now, and how to build each skill without going back to college.",
    category: "Field Notes",
    readTime: "8 min read",
    date: "Nov 12, 2025",
    cover: "https://images.unsplash.com/photo-1559136656-3db4bf6c35f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxjb2xsYWJvcmF0aXZlJTIwbWVldGluZyUyMG1vZGVybiUyMHdvcmtzcGFjZXxlbnwwfHx8fDE3ODU2OTE3MTF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "govt-job-vs-private-sector",
    number: "03",
    title: "Government Job vs. Private Sector: How to Decide What's Right for You",
    excerpt:
      "The most productive years of your life shouldn't be spent second-guessing your choice. An honest, unbiased look at both paths — and the questions to ask yourself before you commit.",
    category: "Aspirants",
    readTime: "9 min read",
    date: "Oct 30, 2025",
    cover: "https://images.pexels.com/photos/30609905/pexels-photo-30609905.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "college-career-planning",
    number: "04",
    title: "Why Most College Students Plan Their Career Too Late",
    excerpt:
      "College is where careers are quietly made or quietly lost. A guide on planning early — without turning your undergrad into a résumé rehearsal.",
    category: "Essay",
    readTime: "6 min read",
    date: "Oct 14, 2025",
    cover: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxjb25maWRlbnQlMjBwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODU2OTE3MTF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "switching-careers-after-30",
    number: "05",
    title: "Switching Careers After 30: What Actually Works",
    excerpt:
      "The playbook for professionals who realised — a few years in — that they built a career on a foundation that was never really theirs. A practical route out.",
    category: "Professionals",
    readTime: "8 min read",
    date: "Sep 28, 2025",
    cover: "https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwY29ycG9yYXRlJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NTY5MTcxMXww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "parents-guide-career-decisions",
    number: "06",
    title: "A Parent's Guide to Supporting Career Decisions (Without Steering Them)",
    excerpt:
      "How to be the calm advisor your child needs — not the pressure they resist. A short read for parents navigating a job market that no longer resembles the one they entered.",
    category: "Parents",
    readTime: "5 min read",
    date: "Sep 09, 2025",
    cover: "https://images.pexels.com/photos/8084481/pexels-photo-8084481.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];
